import { useEffect, useState } from 'react'
import { handleHashChange, navigate } from '@utils/route'

export interface UseHashRoute {
  route: string
  go: (target: string) => void
}

const initialHash = (): string => (typeof window === 'undefined' ? '' : window.location.hash)

/**
 * `window.location.hash` を React state に同期するフック。
 * unknown route は `home` にフォールバックされた状態で返ってくる。
 *
 * - 初期化時 / hashchange 受信時の両方で `handleHashChange` を通す
 * - 同じ hash への navigate はショートサーキット (utils/route.ts navigate)
 */
export const useHashRoute = (): UseHashRoute => {
  const [route, setRoute] = useState<string>(() => handleHashChange(initialHash()))

  useEffect(() => {
    const onHash = (): void => setRoute(handleHashChange(window.location.hash))

    window.addEventListener('hashchange', onHash)

    // 初期化中に他コンポーネントが location.hash を書き換えた可能性を吸収
    onHash()

    return (): void => window.removeEventListener('hashchange', onHash)
  }, [])

  return { route, go: navigate }
}
